export const FORM_FIELD_MODEL = 'model';
export const FORM_FIELD_SERIAL = 'serial';
export const FORM_FIELD_NICK_NAME = 'nickName';
export const SELECTED_EQUIPMENT = 'selectedEquipment';
export const NOTIFY_DEALER = 'notifyDealer';
export const SHOW_DUPLICATE_BANNER = 'showDuplicateEquipmentBanner';
export const TAB_INDEX_SERIAL = 0;
export const EQUIPMENT_SEARCH_FILTER = {
  MODEL: 'model',
  SERIAL: 'serial',
  EQUIPMENT_FAMILY: 'equipmentFamily'
};

export const SEARCH_RESULT_LIMIT = {
  MATCHING: 8,
  OTHERS: 12
};

export const ADD_EQUIPMENT_BY_MODEL_ERRORS = {
  REQUIRED_FIELD: 'root.requiredField',
  MODEL_NOT_FOUND: 'modelNotFound',
  DEFAULT_ERROR: 'root.defaultError'
};

export const MODEL_LOCATION = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20200214-e3574-9840e?wid=374&hei=186',
  alt: 'model location'
};

export const SERIAL_NUMBER_HELP_ASSETS = {
  NEWER_ASSETS: {
    src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20220208-8552a-03070?wid=319&hei=160',
    alt: 'newer assets'
  },
  NEWER_ASSETS_MODEL: {
    src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20220208-e9624-c99b5?wid=300&hei=81',
    alt: 'newer asset model'
  },
  ASSET_PLATE_BEFORE: {
    src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20220208-e3a2c-0b730?wid=252&hei=160',
    alt: 'asset plate before 2002'
  },
  ASSET_PLATE_BEFORE_MODEL: {
    src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20220208-ab41f-ff534?wid=140&hei=112',
    alt: 'asset plate before 2002 model'
  },
  ENGINES_AND_GENERATORS: {
    src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20220208-a2894-08f88?wid=289&hei=160',
    alt: 'engines and generators'
  },
  ENGINES_AND_GENERATORS_MODEL: {
    src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20220208-37a04-9841a?wid=140&hei=81',
    alt: 'engines and generators model'
  },
  WHERE_TO_FIND_SERIAL: {
    src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20220208-ad620-d01ab?wid=374&hei=186',
    alt: 'Where to find an asset serial number plate?'
  }
};

export const SEARCH_LENGTH = {
  MAX: 8
};

export const WIDGET_IDENTIFIER = {
  ADD: 'add',
  EDIT: 'edit'
};

export const EQUIPMENT_IMAGE_PARAMS =
  '?hei=60&wid=80&qlt=85,0&resMode=sharp2&op_usm=1.75,0.3,2,0';
export const SERIAL_MATCH_IMAGE_PARAMS =
  '?hei=44&wid=57&qlt=85,0&resMode=sharp2&op_usm=1.75,0.3,2,0';

export const MEQ_SERIAL_NO_MATCH = 'MEQ_SERIAL_NO_MATCH';
export const MEQ_MODEL_NO_MATCH = 'MEQ_MODEL_NO_MATCH';
export const GENERIC_ERROR = 'GENERIC_ERROR';
export const DUPLICATE_EQUIPMENT_ERROR = 'DUPLICATE_EQUIPMENT_ERROR';
export const UNKNOWN_ERROR_MESSAGE = 'UNKNOWN_ERROR_MESSAGE';
export const FAILED_TO_FETCH = 'Failed to fetch';
export const INTERNAL_SERVER_ERROR = 500;
export const SHARE_EQUIPMENT_DEALER_EMAIL_ERROR =
  'SHARE_EQUIPMENT_DEALER_EMAIL_ERROR';

type FaultInject = {
  [key: string]: {
    type: string;
    genericError: string;
  };
};
export const FAULT_INJECT: FaultInject = {
  ADD_EQUIPMENT: {
    type: 'faultInject_AddEquipment',
    genericError: GENERIC_ERROR
  },
  DELETE_EQUIPMENT: {
    type: 'faultInject_DeleteEquipment',
    genericError: GENERIC_ERROR
  },
  EDIT_EQUIPMENT: {
    type: 'faultInject_EditEquipment',
    genericError: GENERIC_ERROR
  },
  EDIT_EQUIPMENT_SEARCH_SUGGESTIONS: {
    type: 'faultInject_EditEquipmentSearchSuggestions',
    genericError: GENERIC_ERROR
  },
  EQUIPMENT_SEARCH_SUGGESTIONS: {
    type: 'faultInject_EquipmentSearchSuggestions',
    genericError: GENERIC_ERROR
  },
  SELECT_EQUIPMENT: {
    type: 'faultInject_SelectEquipment',
    genericError: GENERIC_ERROR
  },
  DESELECT_EQUIPMENT: {
    type: 'faultInject_DeselectEquipment',
    genericError: GENERIC_ERROR
  },
  FILE_UPLOAD: {
    type: 'faultInject_FileUpload',
    genericError: GENERIC_ERROR
  },
  CREATE_SAVED_LIST: {
    type: 'faultInject_CreateSavedList',
    genericError: GENERIC_ERROR
  },
  GET_SAVED_LISTS: {
    type: 'faultInject_GetSavedLists',
    genericError: GENERIC_ERROR
  },
  GET_EQUIPMENT_LIST: {
    type: 'faultInject_GetEquipmentList',
    genericError: GENERIC_ERROR
  },
  GET_MACHINE_DETAILS: {
    type: 'faultInject_GetMachineDetails',
    genericError: GENERIC_ERROR
  },
  GET_PARTS_DIAGRAM: {
    type: 'faultInject_SystemAndComponents',
    genericError: GENERIC_ERROR
  }
};

export const AddEquipmentToast = 'addEquipmentToast';

export const EQUIPMENT_ACTION = [
  {
    text: 'VIEW_DASHBOARD',
    key: 'VIEW_DASHBOARD'
  },
  {
    text: 'SHOP_PM_KITS',
    key: 'SHOP_PM_KITS'
  },
  {
    text: 'CAT_PARTS_DIAGRAM',
    key: 'CAT_PARTS_DIAGRAM'
  },
  {
    text: 'REQUEST_SERVICE',
    key: 'REQUEST_SERVICE'
  }
];

export enum BUTTON_VARIANTS {
  PRIMARY = 'primary',
  CONTRAST = 'contrast',
  GHOST = 'ghost',
  DANGER = 'danger'
}

export enum BUTTON_SIZES {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg'
}

export const DELETE = 'DELETE';
export enum VARIANTS {
  TITLE_SMALL = 'title-sm',
  BODY_SMALL = 'body-sm'
}
export const LOCATION_HASH_KEY = {
  SHOP_PARTS: '#shopParts',
  PM_KITS: '#pmKits',
  OMM: '#OMMManuals',
  MAINTENANCE_REPAIRS: '#maintenanceAndRepairs',
  SERVICE_INSIGHT: '#serviceInsight',
  REQUEST_SERVICE: '#requestService'
};
export const MY_EQUIP_GA_EVENTS = {
  PRIMARY_CTA: 'e_primaryCTA',
  CONTEXT: 'My equipment Page Currently shopping for section',
  SELECT: 'select equipment section',
  CHANGE: 'change equipment section'
};

export const MY_EQP_SCHEMA = {
  VIEW_DASHBOARD: 'VIEW_DASHBOARD',
  SHOP_PARTS: 'SHOP_PARTS',
  CAT_PARTS_DIAGRAM: 'CAT_PARTS_DIAGRAM',
  REQUEST_SERVICE: 'REQUEST_SERVICE',
  ALP_MAINTENANCE_REPAIRS: 'ALP_MAINTENANCE_REPAIRS',
  CLEAR_SELECTION: 'CLEAR_SELECTION',
  PLEASE_SELECT: 'PLEASE_SELECT',
  EDIT: 'CUST_EDIT',
  DELETE: 'DELETE',
  LN_SEARCH_FACET_MORE: 'LN_SEARCH_FACET_MORE',
  MORE: 'MORE'
};

export const DISPLAY_PAGE_COUNT = 50;
export const MYEQUIPMENT_GUEST_BANNER = 'MY_EQUIPMENT_GUEST_BANNER';
